import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitySectionPanel from 'components/organisms/SectionPanels/EntitySectionPanel/EntitySectionPanel';

const StyledCollectionEntitySectionPanel = styled(EntitySectionPanel)`
  .CollectionEntitySectionPanel-options-footer {
    .Button {
      min-width: 100%;
    }
  }
  
  ${ComponentStyles}
`;

StyledCollectionEntitySectionPanel.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitySectionPanel;
